import React from 'react';
import { Modal as RSModal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import cx from 'classnames';
import Button from '@components/Button';
import useTranslation from '@util/hooks/useTranslation';

const Modal = ({
    className,
    headerClassName,
    bodyClassName,
    footerClassName,
    headerTitle,
    bodyText,
    modalHeader,
    modalBody,
    modalFooter,
    initModal = false,
    toggleModal = function () {
        initModal = !initModal;
    },
    okCallback,
    okValidation = true,
    callbackParam,
    cancelCallback,
    removeCancel,
    children,
    ...restProps
}) => {
    const t = useTranslation('ConfirmModal');
    return (
        <RSModal
            backdrop={'static'}
            container={document.getElementsByClassName('app-container')[0]}
            className={cx('pnt-modal', className)}
            isOpen={initModal}
            toggle={toggleModal}
            {...restProps}
        >
            {modalHeader ? (
                modalHeader
            ) : (
                <ModalHeader
                    className={headerClassName}
                    toggle={() => {
                        if (typeof cancelCallback === 'function') {
                            cancelCallback();
                        }
                        toggleModal();
                    }}
                >
                    {headerTitle}
                </ModalHeader>
            )}
            {children ? children : <ModalBody className={bodyClassName}>{bodyText}</ModalBody>}
            {modalFooter ? (
                modalFooter
            ) : (
                <ModalFooter className={footerClassName}>
                    {!removeCancel && (
                        <Button
                            className={'btn-gray'}
                            onClick={e => {
                                if (typeof cancelCallback === 'function') {
                                    cancelCallback(callbackParam);
                                }
                                toggleModal();
                            }}
                        >
                            {t('Cancel')}
                        </Button>
                    )}

                    <Button
                        className={'btn-secondary'}
                        onClick={e => {
                            if (typeof okCallback === 'function') {
                                okCallback(callbackParam);
                            }
                            if (okValidation) {
                                toggleModal();
                            }
                        }}
                    >
                        {t('OK')}
                    </Button>
                </ModalFooter>
            )}
            {/*
                modal react-select portal
                modal의 경우 app-main__inner 태그 밖에 생성되므로
                select menu portal 대상을 내부에서 정의해야 함
            */}
            <div id="modal-select-container" />
        </RSModal>
    );
};

export default Modal;
